'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Search } from '@morpho-org/ui-v6/client';
import { cn } from '@morpho-org/ui-v6/utils';
const SEARCH_DEBOUNCE_TIME = 500;
interface MarketTableFiltersProps {
  masterFilterSlot: ReactNode;
  networkFilterSlot?: ReactNode;
  collateralFilterSlot?: ReactNode;
  loanFilterSlot?: ReactNode;
  holdingsFilterSlot?: ReactNode;
  sortBySlot?: ReactNode;
  editPropertiesSlot?: ReactNode;
  fullscreenSlot?: ReactNode;
  searchValue: string;
  onSearchChange: (value: string) => void;
  disabled: boolean;
}
const MarketTableFilters = t0 => {
  const $ = _c(23);
  const {
    masterFilterSlot,
    networkFilterSlot,
    collateralFilterSlot,
    loanFilterSlot,
    holdingsFilterSlot,
    sortBySlot,
    editPropertiesSlot,
    fullscreenSlot,
    searchValue,
    onSearchChange,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex justify-between flex-row gap-sm", cn("max-lg:flex-col", false && "max-sm:py-sm max-sm:mt-md", false && "max-sm:sticky max-sm:top-[calc(var(--navbar-height)-0.5px)] max-sm:z-10 max-sm:bg-background"));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== sortBySlot) {
    t2 = <div className="contents lg:hidden">{sortBySlot}</div>;
    $[1] = sortBySlot;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== collateralFilterSlot || $[4] !== holdingsFilterSlot || $[5] !== loanFilterSlot || $[6] !== masterFilterSlot || $[7] !== networkFilterSlot || $[8] !== t2) {
    t3 = <div className="flex flex-1 justify-between max-lg:justify-start"><div className="gap-sm flex flex-wrap items-center">{networkFilterSlot}{loanFilterSlot}{collateralFilterSlot}{masterFilterSlot}{holdingsFilterSlot}{t2}</div></div>;
    $[3] = collateralFilterSlot;
    $[4] = holdingsFilterSlot;
    $[5] = loanFilterSlot;
    $[6] = masterFilterSlot;
    $[7] = networkFilterSlot;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== disabled || $[11] !== onSearchChange || $[12] !== searchValue) {
    t4 = <div className="flex-1"><Search placeholder="Filter markets" data-testid="table-search" fullWidth={true} value={searchValue} onChange={onSearchChange} disabled={disabled} debounceTime={SEARCH_DEBOUNCE_TIME} isGlobalSearchInput={false} /></div>;
    $[10] = disabled;
    $[11] = onSearchChange;
    $[12] = searchValue;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== editPropertiesSlot || $[15] !== fullscreenSlot) {
    t5 = <div className="contents max-lg:hidden">{editPropertiesSlot}{fullscreenSlot}</div>;
    $[14] = editPropertiesSlot;
    $[15] = fullscreenSlot;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div data-testid="listing-search" className="gap-sm flex items-center">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t3 || $[21] !== t6) {
    t7 = <div className={t1}>{t3}{t6}</div>;
    $[20] = t3;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default MarketTableFilters;